<script setup lang="ts">
import { toRefs } from "vue";
import { RouterLink } from "vue-router";
import type { Order } from "@/rvapi";

const props = defineProps<{
  orders: Order[];
  searching: boolean;
}>();

const { orders, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && orders.length > 0">
    <h3>Found orders related to file</h3>
    <p>
      If strålfors has detected a broken file, it will still be marked as SENT
      in our systems. Please check the order page for postcards associated with
      the broken file and resend them.
    </p>
    <p>
      The file name will be listed both under "zipfiles" and in the "batchid"
      columns on the order page. After a resend, both filenames will be in the
      zipfiles list, but only the latest one sent will be displayed as batchid.
    </p>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>OrderId</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.orderId">
            <td>
              <RouterLink
                v-show="order.orderId"
                :to="'/order/' + order.orderId"
              >
                {{ order.orderId }}
              </RouterLink>
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
